import { useSuspenseQuery } from '@apollo/client';
import { useSearchingStore } from '../store/useSearchStore';
import {
  FetchSearchPageQuery,
  FetchSearchPageQueryVariables,
  QUERY_SEARCH_FETCH_PAGE,
  QUERY_KNOWLEDGE_BASE_TYPES_WITH_PUBLISHED_ITEMS,
  FetchKnowledgeBaseTypesWithPublishedItemsQuery,
  SearchPage,
} from '@edwin-group/people-graphql';
import { useEffect } from 'react';

export const useRoot = () => {
  const { setSearchPage } = useSearchingStore();

  const { data } = useSuspenseQuery<FetchSearchPageQuery, FetchSearchPageQueryVariables>(QUERY_SEARCH_FETCH_PAGE, {
    fetchPolicy: 'cache-first',
  });

  const { data: typesData } = useSuspenseQuery<FetchKnowledgeBaseTypesWithPublishedItemsQuery>(
    QUERY_KNOWLEDGE_BASE_TYPES_WITH_PUBLISHED_ITEMS,
    { fetchPolicy: 'cache-first' },
  );

  useEffect(() => {
    if (data && typesData) {
      const knowledgeBaseTypes = typesData.knowledgeBaseTypesWithPublishedItems ?? [];
      setSearchPage((data.searchPage as SearchPage) || null, knowledgeBaseTypes);
    }
  }, [data, typesData, setSearchPage]);

  return {};
};
